import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {
  addLikeInShort,
  getShorts,
  addCommentShortVideo,
  getCommentShortVideoById,
} from "../../utils/api";
import { useUserContext } from "../../utils/hooks/UserContext";
import { FaRegHeart } from "react-icons/fa6";
import { toast } from "react-toastify";
import ShareDataComp from "../../Coach/components/ShareData";
import Pic from "../../assets/images/icons/user.png";
import { FaRegComment } from "react-icons/fa6";

const InstagramReelCarousel = () => {
  const { user } = useUserContext();
  const [reels, setVideo] = useState([]);
  const [showSocial, setShowSocial] = useState(false);
  const [showSocialId, setShowSocialId] = useState(null);
  const [activeReel, setActiveReel] = useState(0);
  const [commentId, setCommentId] = useState(0);
  const [showComments, setShowComments] = useState(false);
  const [currentReelId, setCurrentReelId] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const swiperRef = useRef(null);
  const [showSocialIcon, setShowSocialIcon] = useState(false);
  // useEffect(() => {
  //   const videos = document.querySelectorAll("video");
  //   videos.forEach((video) => {
  //     video.muted = true;
  //     video.pause(); // Optional: stop autoplay if any
  //   });
  // }, []);

  // Mock comments data
  const mockComments = [
    { id: 1, user_name: "fitness_lover", comment: "Great workout! 💪" },
    { id: 2, user_name: "gym_enthusiast", comment: "I do this every morning!" },
    { id: 3, user_name: "health_coach", comment: "Perfect form demonstrated!" },
    {
      id: 4,
      user_name: "beginner_trainee",
      comment: "This was really helpful, thanks!",
    },
    {
      id: 5,
      user_name: "pro_athlete",
      comment: "Nice variation of the exercise!",
    },
  ];

  const getData = async () => {
    const { data } = await getShorts();
    setVideo(data?.data);
  };

  useEffect(() => {
    getData();
  }, []);

  // useEffect(() => {
  //   fetchComments(reels?.[0]?.short_video_id);
  // }, []);

  const fetchComments = async (id) => {
    try {
      const response = await getCommentShortVideoById(id);
      setComments(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddComment = async (id) => {
    try {
      if (!user) {
        toast.error("Please login to do this action");
        return;
      } else if (user?.userType === "coach") {
        toast.error("Please login as user to do this action");
        return;
      }
      const formdata = new FormData();
      formdata.append("short_video_id", id);
      formdata.append("comments", newComment);

      const res = await addCommentShortVideo(formdata);
      if (!res?.data?.status) {
        toast.error(res.data?.message);
        return;
      }
      const newCommentObj = {
        id: comments.length + 1,
        name: user?.name || "current_user",
        comments: newComment,
      };

      setComments([...comments, newCommentObj]);
      setNewComment("");
      toast.success("New comment added.");
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      // fetchComments(id)
      getData();
    }
  };
  // const fetchComments = (videoId) => {
  //   // Mock implementation - return mock comments after a short delay
  //   setTimeout(() => {
  //     setComments(mockComments);
  //   }, 300);
  // };

  const onClickLike = async (id) => {
    if (!user) {
      toast.error("Please login to do this action");
      return;
    } else if (user?.userType === "coach") {
      toast.error("Please login as user to do this action");
      return;
    }
    const formdata = new FormData();
    formdata.append("short_video_id", id);
    await addLikeInShort(formdata);
    getData();
  };

  const displaySocialIcon = (id) => {
    setShowSocial(!showSocial);
    setShowSocialId(id);
    if (showSocial === false) {
      navigator.clipboard
        .writeText(`qoach.io/single-short/` + id)
        .then(() => {
          toast.success("Link Copied to Clipboard!");
        })
        .catch((err) => {
          console.error("Unable to copy text to clipboard", err);
        });
    }
  };

  const toggleComments = (reelId) => {
    if (!user) {
      toast.error("Please login to view comments");
      return;
    }
    setCommentId(reelId);
    setCurrentReelId(reelId);
    fetchComments(reelId);
    setShowComments(!showComments);
  };

  // const handleAddComment = () => {
  //   if (!newComment.trim()) return;

  //   // Mock implementation - add new comment to the array
  //   const newCommentObj = {
  //     id: comments.length + 1,
  //     user_name: user?.username || "current_user",
  //     comment: newComment,
  //   };

  //   setComments([...comments, newCommentObj]);
  //   setNewComment("");

  //   // In a real implementation, you would update the comment count here
  //   // For now, we'll just show a success message
  //   toast.success("Comment added!");
  // };

  return (
    <div style={{ position: "relative", padding: "0 40px" }} className="w-100">
      {/* Navigation Buttons */}
      <button
        onClick={() => swiperRef.current?.swiper?.slidePrev()}
        style={{
          position: "absolute",
          left: "0",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 10,
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          backgroundColor: "rgba(0,0,0,0.5)",
          border: "none",
          color: "white",
          fontSize: "20px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        &lt;
      </button>

      <button
        onClick={() => swiperRef.current?.swiper?.slideNext()}
        style={{
          position: "absolute",
          right: "0",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 10,
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          backgroundColor: "rgba(0,0,0,0.5)",
          border: "none",
          color: "white",
          fontSize: "20px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        &gt;
      </button>

      <Swiper
        ref={swiperRef}
        modules={[Navigation, A11y]}
        spaceBetween={30}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        // onSlideChange={(swiper) => setActiveReel(swiper.activeIndex)}
        onSlideChange={(swiper) => {
          setActiveReel(swiper.activeIndex);
          setShowComments(false);
        }}
        style={{
          height: "540px",
          width: "100%",
          padding: "5px 29px 5px 5px",
        }}
        breakpoints={{
          500: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
        }}
      >
        {reels.map((reel, index) => (
          <SwiperSlide key={reel.short_video_id}>
            <div
              className="overflow-hidden bg-black position-relative rounded-3xl"
              style={{
                position: "relative",
                width: "308px",
                height: "100%",
                cursor: "pointer",
                transform:
                  activeReel === index || index === reels.length - 1
                    ? "scale(1)"
                    : index === reels.length - 2
                    ? "scale(0.7)"
                    : "scale(0.7)",
                transition: "transform 0.3s ease-in-out",
              }}
            >
              {/* Video Player */}
              {/* <iframe
                width="100%"
                height="100%"
                className="object-cover w-full h-full rounded-3xl position-relative"
                // src={`${
                //   process.env.REACT_APP_COACH_SHORT_VIDEO_PATH + reel?.file_url
                // }?mute=1`}
                src={`${process.env.REACT_APP_COACH_SHORT_VIDEO_PATH + reel?.file_url}?autoplay=0&mute=1&enablejsapi=1`}
                title={`Reel ${reel.short_video_id}`}
                frameBorder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay; muted"
                allowFullScreen
                style={{
                  objectFit: "cover",
                  backgroundColor: "#000",
                }}
                muted
              ></iframe> */}

              <video
                src={`${
                  process.env.REACT_APP_COACH_SHORT_VIDEO_PATH + reel?.file_url
                }`}
                className="object-cover w-full h-full rounded-3xl position-relative"
                controls={true}
                muted
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  backgroundColor: "#000",
                  borderRadius: "1.5rem",
                }}
              ></video>

              {/* Reel Info Overlay */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  padding: "16px",
                  right: 0,
                  background:
                    "linear-gradient(to bottom,  rgba(0,0,0,0.9), transparent)",
                  color: "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <div className="z-20 bg-[#dddd] rounded-full">
                    <img
                      src={
                        reel?.coach_profile
                          ? `${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${reel?.coach_profile}`
                          : Pic
                      }
                      className={`rounded-5 w-[40px] h-[40px] border border-white object-fit-cover ${
                        !reel?.coach_profile ? "default-profile" : ""
                      }`}
                      alt="Coach Profile"
                    />
                  </div>
                  <span
                    className=" bg-[#00504E] -ml-4 z-10 p-2 ps-4 rounded-2"
                    style={{ fontWeight: "600" }}
                  >
                    @{reel.coach_name}
                  </span>
                </div>

                {reel.caption && (
                  <p
                    style={{
                      marginBottom: "8px",
                      fontSize: "14px",
                      lineHeight: "1.4",
                    }}
                  >
                    {reel.caption}
                  </p>
                )}

                {reel?.tags && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "4px",
                      marginBottom: "12px",
                    }}
                  >
                    {reel?.tags?.split(",")?.map((i) => (
                      <span
                        key={i}
                        className="capitalize-label"
                        style={{ fontSize: "14px", fontWeight: "500" }}
                      >
                        #{i}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {/* Right Side Action Buttons */}
              <div
                style={{
                  position: "absolute",
                  right: "12px",
                  bottom: "80px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "15px",
                  padding: "16px",
                }}
              >
                {/* Like Button */}
                <div
                  style={{ textAlign: "center" }}
                  onClick={() => onClickLike(reel?.short_video_id)}
                >
                  <div
                    className="bg-[#5a5956c5]"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    {reel?.is_liked ? (
                      "❤️"
                    ) : (
                      <FaRegHeart className="text-white" />
                    )}
                  </div>
                  <span
                    style={{
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    {reel?.like_count}
                  </span>
                </div>

                {/* Comment Button */}
                <div
                  style={{ textAlign: "center" }}
                  className="position-relative rounded-5 bg-[#5a5956c5]"
                  onClick={() => toggleComments(reel?.short_video_id)}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <FaRegComment className="text-white" />
                  </div>
                </div>
                <span
                  style={{
                    fontSize: "12px",
                    display: "block",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  {reel?.comment_count}
                </span>

                {/* Share Button */}
                <div
                  style={{ textAlign: "center" }}
                  onClick={() => displaySocialIcon(reel?.short_video_id)}
                >
                  <div
                    className="bg-[#5a5956c5] reelsss"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px",
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <ShareDataComp
                      setShowSocial={setShowSocialIcon}
                      showSocial={activeReel === index && showSocialIcon}
                      active={true}
                    />
                  </div>
                  <span
                    style={{
                      fontSize: "12px",
                      marginTop: "4px",
                      color: "white",
                      fontWeight: "bold",
                      display: "block",
                    }}
                  >
                    Share
                  </span>
                </div>
              </div>
              {/* Comment Section */}
              {showComments && commentId === reel.short_video_id && (
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: "80%",
                    width: "100%",
                    backgroundColor: "white",
                    zIndex: 1000,
                    padding: "16px",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                    boxShadow: "0 -5px 10px rgba(0,0,0,0.2)",
                    overflowY: "auto",
                  }}
                  className="hideScrollbar"
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <h3>Comments</h3>
                    <button
                      onClick={() => setShowComments(false)}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                    >
                      ×
                    </button>
                  </div>

                  <div
                    style={{
                      marginBottom: "16px",
                      maxHeight: "60%",
                      overflowY: "auto",
                    }}
                    className="hideScrollbar"
                  >
                    {comments.length > 0 ? (
                      comments.map((comment) => (
                        <div
                          key={comment.id}
                          style={{
                            marginBottom: "12px",
                            paddingBottom: "12px",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          <div style={{ fontWeight: "bold" }}>
                            @{comment.name}
                          </div>
                          <div>{comment.comments}</div>
                        </div>
                      ))
                    ) : (
                      <div>No comments yet</div>
                    )}
                  </div>

                  <div
                    style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                  >
                    <input
                      type="text"
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      placeholder="Add a comment..."
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        borderRadius: "20px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <button
                      onClick={() => handleAddComment(reel?.short_video_id)}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "20px",
                        backgroundColor: "#0D4644",
                        color: "white",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      Post
                    </button>
                  </div>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default InstagramReelCarousel;
